import { render } from "./PlayoutItemV2.vue?vue&type=template&id=0b788712"
import script from "./PlayoutItemV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutItemV2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutItemV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b788712"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b788712', __exports__)) {
    api.reload('0b788712', __exports__)
  }
  
  module.hot.accept("./PlayoutItemV2.vue?vue&type=template&id=0b788712", () => {
    api.rerender('0b788712', render)
  })

}


export default __exports__